import { updateField } from '@frontend/repository';
import { SpotSelectV2 } from '@frontend/spot/select';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useDestinationConstraintDataInput from './destination-constraint-data-input.controller';

const ID = 'destination-constraint-data-input';
export interface DestinationConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const DestinationConstraintDataInput = (props: DestinationConstraintDataInputProps) => {
    const viewProps = useDestinationConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full'>
            <SpotSelectV2
                required
                value={viewProps.formValues?.spot_id ?? null}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { spot_id: v } : undefined }));
                }}
            />
        </div>
    );
};

export default DestinationConstraintDataInput;
